import styled from "styled-components"
import {
    // COLOR,
    // FONT
} from 'assets'
 
export const CreatorContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
  
`